import getCookieSettings from './getCookieSettings'

export const COOKIE_SETTINGS_EVENT = 'ta2021-cookie-settings-show'
export const COOKIE_CONSENT_EVENT = 'ta2021-cookie-consent-show'
export const TRIGGER_AND_CLOSE_MODAL_EVENT =
  'ta2021-cookie-consent-trigger-and-close'

export default function triggerEvent(eventName: string) {
  const detail = getCookieSettings()
  // console.log('trigger event', eventName, { detail })
  const e = new CustomEvent(eventName, { detail })
  document.dispatchEvent(e)
}
